/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 19th 2021, 9:42:25 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { APIMany2OnePopupFormInput, IconText, Typography, ConcreteAPIRelatedFormPopupInputProps } from "ui-widgets";
import { DesignLayout } from "lib/schemas";
import { DesignLayoutForm } from "service-builder/components/layouts";
import { COLORSCHEME } from "theme/styles";
import { PenTool } from "react-feather";
import { useGlobalScope } from "core/providers/GlobalScopeProvider";

interface HTMLLayoutPopupInputProps<T> extends ConcreteAPIRelatedFormPopupInputProps<T, DesignLayout> {
  layout_type: DesignLayout["layout_type"];
}
export const HTMLLayoutPopupInput = <T,>(props: HTMLLayoutPopupInputProps<T>) => {
  const { popUpTitle, layout_type, ...otherProps } = props;

  const { globalState } = useGlobalScope();

  const newDesignLayoutDefault: DesignLayout = {
    title: "",
    active: true,
    css: `.${layout_type}-custom-layout {}`,
    html_design: "",
    layout_type,
    artifact_org: globalState.selectedOrganization?.id,
  };

  return (
    <APIMany2OnePopupFormInput<T, DesignLayout>
      renderRelatedObjectForm={({ foreignKeyID, updatePrimaryObject, handleClose }) => (
        <DesignLayoutForm
          designLayoutID={foreignKeyID}
          newDesignLayoutDefault={newDesignLayoutDefault}
          onFormCancel={handleClose}
          onSuccessfulAPISave={(designLayout) => updatePrimaryObject(designLayout.id)}
        />
      )}
      label={props.label ?? "HTML Layout"}
      popUpTitle={
        <IconText
          icon={<PenTool color={COLORSCHEME.secondaryVariant} />}
          textComponent={<Typography variant="h5">{popUpTitle ?? props.label}</Typography>}
        />
      }
      popUpDescription={props.popUpDescription ?? "HTML Design Layout."}
      itemIdProperty="id"
      getOptionLabel={(option) => option.title}
      {...otherProps}
    />
  );
};
